module.exports = ".time-picker-button {\n  padding: 0;\n  margin: 0;\n  min-width: 44px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/time-control/w-mat-timepicker/w-mat-timepicker.component.scss
// module id = 1599
// module chunks = 0